import BaseAPI from '@/apis/base/baseApi';
import httpclient from '../base/httpclient';
class NotificationApi extends BaseAPI {
  apiName = 'Other';
  controllerName = 'Notifications';

  /**
   * Lấy thông báo mới nhất
   * ndhieu3 25.09.2023
   */
  getNewestNoti() {
    try {
      let request = {
        url: this.getAPIUrl() + '/newest-noti',
      };
      return httpclient.getAsync(request);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Lấy ds thông báo
   */
  getNoti(payload) {
    let request = {
      url: this.getAPIUrl() + '/getNoti',
      data: payload,
    };

    return httpclient.postAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách
   */
  updateRead(payload) {
    let request = {
      url: this.getAPIUrl() + '/read',
      data: payload,
    };

    return httpclient.postAsync(request);
  }

  /**
   * Lấy số thông báo chưa đọc
   */
  getUnread(payload) {
    let request = {
      url: this.getAPIUrl() + '/unread',
      data: payload,
    };

    return httpclient.postAsync(request);
  }

  /**
   * Thử insert noti
   */
  tryInsertNoti(cacheNotiId){
    try{
      let request = {
        url: this.getAPIUrl() + `/try-insert-noti/${cacheNotiId}`,
      };
  
      return httpclient.postAsync(request);
    } catch (e){
      return null;
    }
  }
}
export default new NotificationApi();
